import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { toggleModal } from "../../redux/reducers/Products/actions";
import {
  selectModalType,
  selectProductToEdit,
} from "../../redux/reducers/Products/selectors";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ProductModalForm from "../ProductModalForm/ProductModalForm";
import WinePartProductModal from "../WinePartProductModal/WinePartProductModal";

import { placeLocation } from "../../_const";

import {
  AddProductModalContainer,
  AddProductTitle,
  CloseIconButton,
} from "./product-modal.style";
import { selectCategoryBySlug } from "../../redux/reducers/Categories/selectors";
import SubCategoryPartProductModal from "../SubCategoryPartProductModal/SubCategoryPart.ProductModal";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ProductModal = ({ currentCategory }) => {
  const { type, open } = useSelector(selectModalType);
  const productToEdit = useSelector(selectProductToEdit);

  const dispatch = useDispatch();
  const initialState = {
    _id: "",
    title: "",
    description: "",
    price: "",
    location: placeLocation,
    category: "",
    visible: true,
    show: "always",
    couleur: [
      { value: "rouge", isChecked: false, price: "" },
      { value: "blanc", isChecked: false, price: "" },
      { value: "rosé", isChecked: false, price: "" },
      { value: "au verre", isChecked: false, price: "" },
    ],
    subCategory: "",
    image: null,
  };

  const [product, setProduct] = useState(initialState);

  useEffect(() => {
    if (type === "ajouter") {
      setProduct((prevState) => ({
        ...initialState,
        category: currentCategory,
        location: placeLocation,
      }));
    }
    if (type === "editer") {
      setProduct((prevState) => ({
        ...prevState,
        ...productToEdit,
      }));
    }
  }, [currentCategory, productToEdit, type, open]);

  const currentCategoryObject = useSelector(selectCategoryBySlug(currentCategory));

  return (
    <AddProductModalContainer open={open} className="modal">
      <AddProductTitle>
        <h3>{`${type?.toUpperCase()}`}</h3>
        <CloseIconButton
          type="button"
          onClick={() => dispatch(toggleModal(type))}
        >
          <FontAwesomeIcon icon={faTimes} size="1x" />
        </CloseIconButton>
      </AddProductTitle>
      <ProductModalForm
        type={type}
        setProduct={setProduct}
        initialState={initialState}
        dispatch={dispatch}
        {...product}
      >
        {currentCategory === "cave" && (
          <WinePartProductModal
            couleur={product.couleur}
            setProduct={setProduct}
          />
        )}
        {currentCategoryObject?.subCategory?.length > 0 && (
          <SubCategoryPartProductModal
            subCategories={currentCategoryObject.subCategory}
            setProduct={setProduct}
            subCategory={product.subCategory}
          />
        )}
      </ProductModalForm>
    </AddProductModalContainer>
  );
};

export default ProductModal;
